import React from 'react';
import * as ReactDOM from "react-dom";
import {withRouter} from "../../withRouter";
import {Badge, Col, Container, ListGroup, NavLink, Row} from "react-bootstrap";

class DeveloperConsole extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            isLoadedData: false,
            isLoadedGeneralInfo: false,
            error: null,
            generalInfo: [],
            userId: null,
            loginError: null,
        };
    }

    loadCompanies(){
        fetch(process.env.REACT_APP_API_URL + "/customer/" + this.state.userId, {
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedGeneralInfo: true,
                        generalInfo: result.data
                    });
                },

                (error) => {
                    this.setState({
                        isLoadedGeneralInfo: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'publisher') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        }, this.loadCompanies);
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        loginError: "unauthorized",
                    });
                }
            );
    }

    render() {
        const { isLoaded, isLoadedGeneralInfo, generalData, loginError, generalInfo} = this.state;

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        let content = null;

        if (isLoadedGeneralInfo) {
            content =
                <center>
                    <div class="center-block col-md-4" style={{
                        marginTop: "15%",
                        marginBottom: "15%",
                        width:"400px",
                        maxWidth:"100%"
                    }}>
                        <ListGroup as="ul">
                    {generalInfo.companies.map(item => (
                    <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                    >
                        <a style={{
                            textDecoration: "none",
                            color: "black"
                        }} href={'/account/company/' + item.id.toString()}>
                            <div className="ms-2 me-auto">
                                <div className="fw-bold">{item.name}</div>
                            </div>
                        </a>
                            <Badge bg="primary" pill>
                                {item.games ? item.games.length : 0}
                            </Badge>
                    </ListGroup.Item>
                    ))}
                </ListGroup>

                        <br/>
                        <a href="/account/" style={{
                            width: 170,
                            padding: 10,
                            color: "white"
                        }} className="btn btn-primary">
                            My account
                        </a>
            </div>
        </center>;
        } else {
            content = <h1>Loading...</h1>
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>

    }
}

export default withRouter(DeveloperConsole);
